// extracted by mini-css-extract-plugin
module.exports = {"flagSvg":"CountryFlagSvg_flagSvg__bXkXC","flagSize":"CountryFlagSvg_flagSize__JAzbx"};